import * as React         from 'react'
import { Props }         from './types'
import './styles.scss';

export const Button = (props: Props) => {
  const {
    label,
    type: typeProps,
    button,
    style,
    size,
    onClick,
    disabled,
  } = props

  return (
    <button
      type={(typeProps as any) || 'button'}
      className={`button ${button || 'default'} ${size || 'small'}`}
      style={style || {}}
      onClick={onClick}
      disabled={disabled}
      { ...props }
    >
      { typeof label === 'string' && (
        <span>
          {label}
        </span>
      )}
    </button>
  );
};